const getAgendaDayFromQuery = require('./agendaDayFromQuery.util.js');
const {registerModule} = window;

class Agenda {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.revealSelectedDay();
    this.addListeners();
  }

  addListeners() {
    for (let i = 0; i < this.ui.$agendaDays.length; i++) {
      const agendaDay = this.ui.$agendaDays[i];
      agendaDay.addEventListener('click', function() {
        const params = new URLSearchParams(location.search);
        params.set('day', i + 1);
        location.search = params;
      });
      agendaDay.addEventListener('keydown', function(e) {
        const key = e.which || e.keyCode;
        if ([13, 32].includes(key)) {
          e.preventDefault();
          const params = new URLSearchParams(location.search);
          params.set('day', i + 1);
          location.search = params;
        }
      });
    }
  }

  revealSelectedDay() {
    const dayCount = parseInt(this.element.dataset.dayCount, 10);
    const day = getAgendaDayFromQuery(location.search, dayCount);
    this.element.dataset.selectedDay = String(day);
  }

  bindUI() {
    this.ui = {};
    this.ui.$agendaDays = this.element.querySelectorAll('.agenda__day');
  }
}

registerModule('Agenda', Agenda);
